import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  ElementRef,
  ViewChild, Inject, PLATFORM_ID
} from '@angular/core';
import { ApiService } from '../../../shared/services/apiService.service';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs/internal/Subscription';
import {
  FormControl,
  FormBuilder,
  Validators,
} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonService } from '../../../shared/services/common.service';
import { FormErrorService } from '../../../shared/form-validation/form-error.service';
import { RegexService } from '../../../shared/form-validation/regex.service';
import { HttpParams } from '@angular/common/http';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { environment } from '../../../../environments/environment';
import { BehaviourSubjectService } from 'src/app/shared/services/behaviour-subject.service';
import { secureStorage } from '../../../shared/services/encryption/secureservice'
import { ClevertapService } from '../../../shared/services/clevertap/clevertap.service';
import { isPlatformBrowser } from '@angular/common';
import { RootService } from '../../../shared/services/root.service';

@Component({
  selector: 'app-new-login',
  templateUrl: './new-login.component.html',
  styleUrls: ['./new-login.component.scss']
})
export class NewLoginComponent implements OnInit {
 sub: Subscription = new Subscription();
  mobileNo: FormControl = new FormControl(null);
  centerBanners: any = [];
  @Input() mobile_no: any;
  isValid: boolean = false;
  LoginFormGroup: any;
  environment1 = environment.s3bucket.url;
  checkBoxchekedlogin:boolean=false;

  bannerList: any;
  isLoading: any = true;

  customOptionsForBanner: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    navSpeed: 700,
    autoplay: true,
    responsiveRefreshRate: 1000000,
    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 1,
      },
      740: {
        items: 1,
      },
      940: {
        items: 1,
      },
    },
  };

  auth2: any;
  isSentOTP: boolean = false;

  // @ViewChild('loginRef', { static: true }) loginElement!: ElementRef;
  constructor(
    private regexService: RegexService,
    private formErrorService: FormErrorService,
    private apiService: ApiService,
    private router: Router,
    private toastrService: ToastrService,
    private behaviorService: BehaviourSubjectService,
    private commonService: CommonService,
    private localStorage: secureStorage,
    private spinner: NgxSpinnerService,
    private formBuilder: FormBuilder,
    private cleverService: ClevertapService, private storageService: RootService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.LoginFormGroup = this.formBuilder.group({
      mobileNo: [
        '',
        [Validators.required, Validators.pattern(this.regexService.Phone)],
      ],
    });
  }

  isshowLogin: boolean = true;
  isshowOtp: boolean = false;
  isshowSignUp: boolean = false;
  user: any;
  loggedIn: boolean;
  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      try {
        this.cleverService.onPageView("Login Page");
        localStorage.removeItem('signup')
      }
      catch { }
      localStorage.removeItem("loginNumber")

    }
    // this.googleAuthSDK();
  }


  onMobileNoEntered(event: any) {
    if (event.keyCode >= 96 && event.keyCode <= 105) {
    }
  }

  onlyNumberKey(event: any) {
    return this.regexService.NumberKeyEvent(event);
  }

  checkValue(event: any) {
    if (event.value?.length == 10) {
      this.mobileNo = event.value;
      this.isValid = true;
    } else this.isValid = false;
  }
  sentOtp() {
    if (isPlatformBrowser(this.platformId)) {
      if (this.checkBoxchekedlogin) {

      if (this.isSentOTP) {
        return;
      }
      this.isSentOTP = true;
      if (this.LoginFormGroup.status === 'INVALID') {
        this.formErrorService.displayFormErrors(this.LoginFormGroup);
        return;
      }
      this.spinner.show();
      let data = {
        mobile_number: this.mobileNo,
        action_type: 'login',
      };
      this.sub.add(
        this.apiService.sentOtp1(data).subscribe({
          next: (response: any) => {
            this.isSentOTP = false;
            if (response.success) {
              this.toastrService.success(response.data.msg);
              this.spinner.hide();
              // this.mobile_no.emit(this.mobileNo);
              // this.commonService.mobileNo = this.mobileNo;
              this.behaviorService.loginNumber.next(true)
              this.localStorage.setItem("loginNumber", JSON.stringify(this.mobileNo))
              localStorage.removeItem("signup")
              this.isshowLogin = false
              this.isshowOtp = true;
              this.isshowSignUp = false;

              // this.router.navigate(['/otp/']);
              if (isPlatformBrowser(this.platformId)) {
                window.scroll(0, 0);
              }
            }
            else {
                  this.toastrService.warning('Something went wrong!');
                  this.spinner.hide();
                }
            //  else {
            //   this.spinner.hide();
            //   if (response?.data?.msg == 'User is not registered.') {

            //     this.behaviorService.loginNumber.next(true)
            //     this.localStorage.setItem("loginNumber", JSON.stringify(this.mobileNo))
            //     this.isshowLogin = false
            //     this.isshowOtp = false;
            //     this.isshowSignUp = true;
            //     // this.router.navigate(['/signup']);
            //     // this.toastrService.warning(response.data.msg || response.msg);
            //   } else {
            //     this.toastrService.warning('Something went wrong!');
            //     this.spinner.hide();
            //   }
            // }
          },
          error: () => {
            this.toastrService.warning('Something went wrong!');
            this.spinner.hide();
          },
          complete: () => { },
        })
      );
    }
    }
  }

  GetTest(data: any) {
    let url;
    var dataUrl = data.banner_link;
    if (dataUrl) {
      url =
        dataUrl?.replace('https://', '') &&
        dataUrl?.replace(environment.baseUrl, '');
      this.router.navigateByUrl(url);
    }
  }
  public hasRequiredError = (controlName: string): boolean | undefined =>
    this.formErrorService.hasRequiredError(controlName, this.LoginFormGroup);
  public hasPatternError = (controlName: string): boolean | undefined =>
    this.formErrorService.hasPatternError(controlName, this.LoginFormGroup);
  public hasMinLengthError = (controlName: string): boolean | undefined =>
    this.formErrorService.hasPatternError(controlName, this.LoginFormGroup);
  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  // callLoginButton() {
  //   this.auth2.attachClickHandler(
  //     this.loginElement.nativeElement,
  //     {},
  //     (googleAuthUser: any) => {
  //       let profile = googleAuthUser.getBasicProfile();;

  //       /* Write Your Code Here */
  //     },
  //     (error: any) => {
  //       alert(JSON.stringify(error, undefined, 2));
  //     }
  //   );
  // }

  /**
   * Write code on Method
   *
   * @return response()
   */
  // googleAuthSDK() {
  //   (<any>window)['googleSDKLoaded'] = () => {
  //     (<any>window)['gapi'].load('auth2', () => {
  //       this.auth2 = (<any>window)['gapi'].auth2.init({
  //         client_id:
  //           '75812610150-848k224bpq02gqhn4f18sjojluulr4hl.apps.googleusercontent.com',
  //         cookiepolicy: 'single_host_origin',
  //         scope: 'profile email',
  //       });
  //       this.callLoginButton();
  //     });
  //   };

  //   (function (d, s, id) {
  //     var js,
  //       fjs = d.getElementsByTagName(s)[0];
  //     if (d.getElementById(id)) {
  //       return;
  //     }
  //     js = d.createElement('script');
  //     js.id = id;
  //     js.src = 'https://apis.google.com/js/platform.js?onload=googleSDKLoaded';
  //     fjs?.parentNode?.insertBefore(js, fjs);
  //   })(document, 'script', 'google-jssdk');
  // }
  gotoPath(path: any) {
    // return path;
    this.router.navigate([path]);
    // if (isPlatformBrowser(this.platformId)) {
    //   if (this.storageService.getUserData()) {
    //     this.router.navigateByUrl(path)
    //   }
    //   else {
    //     localStorage.setItem('previousUrl', '/home')
    //     this.router.navigate(['/']);
    //   }
    // }
  }

  showLogin() {
    this.checkBoxchekedlogin=false
    this.isshowLogin = true
    this.isshowOtp = false;
    this.isshowSignUp = false;
  }

  showOtp() {
    this.isshowLogin = false
    this.isshowOtp = true;
    this.isshowSignUp = false;
  }

  showSignup(){
         this.isshowLogin = false
         this.isshowOtp = false;
         this.isshowSignUp = true;
  }
  onCheckboxChangelogin(checked: boolean) {
    if (checked) {
      this.checkBoxchekedlogin=true
    } else {
      this.checkBoxchekedlogin=false
    }
  }

}
